import { GoogleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import couple from '~/assets/couple.png';
import partner from '~/assets/partner.png';
import referrer from '~/assets/referrer.png';
import scBackground from '~/assets/sc-back.svg';
import scLogo from '~/assets/sc-logo.svg';
import tracker from '~/assets/tracker.svg';
import { apiUrl } from '~/config';
import { dashboardDefinitions } from '~/utils/constants';
import { gatewayLogo } from '~/utils/constants';

export default function Landing() {
  const login = () => {
    window.location.href = `${apiUrl}/api/auth/google`;
  };

  return (
    <section className="w-full h-[100vh] relative flex justify-center bg-lamf5 bg-no-repeat bg-x-cover bg-bottom">
      <img className="absolute bottom-0 right-0" alt="noImg" src={couple} />
      <div className="flex w-[830px] relative rounded-lg h-fit mt-[7%] bg-[#fff] shadow-lg">
        <img
          src={scBackground}
          alt="sc-logo"
          className="absolute left-[40px] border border-black z-0"
        />
        <div className="flex-1 space-y-4 px-8 py-7 z-10">
          <img src={gatewayLogo} alt="sc-logo" className="h-[30px]" />
          <div className="flex flex-col">
            <p className="text-md text-gray-700">Before you move ahead</p>
            <p className="text-2xl font-bold text-gray-700">
              Understand Key Terms
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <InfoBlock
              imgSrc={partner}
              title="Partners"
              description={dashboardDefinitions.Partners}
            />
            <InfoBlock
              imgSrc={referrer}
              title="Referrers"
              description={dashboardDefinitions.Referrers}
            />
          </div>
        </div>

        <div className="flex-1 space-y-4 p-4">
          <div className="flex justify-end">
            <img src={scLogo} alt="sc-logo" className="h-[60px]" />
          </div>
          <InfoBlock
            imgSrc={tracker}
            title="Journey Tracker"
            description={dashboardDefinitions.Trackers}
          />
          <div className="pt-5 px-10">
            <Button
              onClick={login}
              type="primary"
              className="p-[25px] font-semibold text-md w-full"
            >
              <GoogleOutlined />
              Login with Google
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

const InfoBlock = ({
  imgSrc,
  title,
  description,
}: {
  imgSrc?: string;
  title?: string;
  description?: string;
}) => (
  <div className="flex items-start gap-3">
    <img src={imgSrc} alt={title} className="h-5 w-5" loading="lazy" />
    <div className="flex flex-col">
      <span className="font-bold text-gray-700">{title}</span>
      <p className="text-[#535B562] text-[12.5px]">{description}</p>
    </div>
  </div>
);
